import React from "react";
import { Link, useNavigate } from "react-router-dom";

const DEFAULT_ART = "/assets/images/403.svg";

export default function AccessRestrictedPage({
  title = "Access Restricted",
  subtitle = "You’ve reached a protected area",
  message = "Your account doesn’t include permission to view this page. If you believe this is a mistake, request access or return to a safe page.",
  homePath = "/",
  illustration = DEFAULT_ART, // set "" to hide
  showContactLink = true,
  contactHref = "/support",
  onLogout,
}) {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
    } catch {}
    if (typeof onLogout === "function") onLogout();
    navigate("/login");
  };

  return (
   <div className="min-vh-100 d-flex align-items-center">
         <div className="container py-5">
           <div className="row g-4 align-items-center justify-content-center">
             {/* Illustration */}
             <div className="col-11 col-sm-8 col-md-6 ms-lg-4 col-lg-5 order-1 order-md-2 text-center">
               <img
                 src="/assets/images/403.png"
                 alt="Page not found"
                 className="img-fluid"
                 style={{ maxHeight: 280 }}
               />
             </div>
   
             {/* Text + actions */}
             <div className="col-11 col-sm-10 col-md-6 col-lg-5 order-2 order-md-1">
               <div className="" style={{ borderRadius: 16, marginLeft: 45 }}>
                 <div className="card-body p-4 p-lg-5">
                  
                   <h1 className="h3 fw-bold mb-2">403 – Permission Restricted</h1>
                   <p className="text-muted mb-4">
                    You don’t have access to this section.Please contact your administrator if you believe this is a mistake.
                   </p>
   
                   <div className="d-flex flex-wrap gap-2">
                     <Link to="/login" className="btn btn-primary">
                       Go to Home
                     </Link>
                   
                   </div>
                   
   
                   {/* Optional help text */}
                   <div className="mt-4 small text-muted">
                     Need help? <a href="/support" className="text-decoration-none">Contact support</a>.
                   </div>
                 </div>
               </div>
             </div>
           </div>
   
           {/* Footer (optional) */}
           <div className="text-center text-muted small mt-4">
             © {new Date().getFullYear()} ProjeX. All rights reserved.
           </div>
         </div>
       </div>
  );
}
